import { gql } from '@apollo/client';

// TODO: proper endpoint
export const GET_COMPANY_DETAILS = gql`
    query {
        viewer {
            id
            customer {
                id
                isActive
                streetAddress
                postalCode
                city
                countryCode
                name
                shortName
                timezone
                timezoneOptions
                sendEmailNotification
                emailNotificationCron
                isAutomationDashboardEnabled
                agentChatEnabled
                trainingDataSharingEnabled
                isBillingSameAsShipping
                invoiceEmail
                billingStreetAddress
                billingPostalCode
                billingCity
                billingCountryCode
                samlConfig {
                    id
                    isRequired
                    domain
                    allowSelfRegistration
                    idpEntityId
                    idpSsoUrl
                    idpSloUrl
                    spEntityId
                    spNameIdFormat
                    attributeMapping
                    wantAssertionsSigned
                    wantMessageSigned
                    metadataUrl
                    acsUrl
                }
                mfaConfig {
                    isRequired
                }
                logoUrl
                customizationKey
                customizationInfo
            }
        }
    }
`;

export const UPDATE_CUSTOMER = gql`
    mutation UpdateCustomer($input: UpdateCustomerInput!) {
        updateCustomer(input: $input) {
            success
        }
    }
`;

export const UPDATE_AGENT_CHAT_ENABLED = gql`
    mutation UpdateAgentChatEnabled($input: UpdateCustomerInput!) {
        updateCustomer(input: $input) {
            success
            customer {
                id
                agentChatEnabled
            }
        }
    }
`;

export const UPDATE_TRAINING_DATA_SHARING_ENABLED = gql`
    mutation UpdateTrainingDataSharingEnabled($input: UpdateCustomerInput!) {
        updateCustomer(input: $input) {
            success
            customer {
                id
                trainingDataSharingEnabled
            }
        }
    }
`;

export const UPLOAD_CUSTOMER_LOGO = gql`
    mutation UploadCustomerLogo($file: Upload!) {
        uploadCustomerLogo(file: $file) {
            success
            customer {
                id
                logoUrl
            }
        }
    }
`;

export const DELETE_CUSTOMER_LOGO = gql`
    mutation DeleteCustomerLogo {
        deleteCustomerLogo {
            success
            customer {
                id
                logoUrl
            }
        }
    }
`;

export const CHANGE_EMAIL_NOTIFICATION_SETTINGS = gql`
    mutation EmailNotificationChange($sendEmailNotification: Boolean!, $emailNotificationCron: String!) {
        emailNotificationChange(
            sendEmailNotification: $sendEmailNotification
            emailNotificationCron: $emailNotificationCron
        ) {
            success
        }
    }
`;

export const GET_SSO_CONFIGS = gql`
    query {
        ssoConfigs {
            id
            isRequired
            providerName
            domain
            allowSelfRegistration
            tenantId
            clientId
        }
    }
`;

export const CREATE_SSO_CONFIG = gql`
    mutation ($input: CreateSSOConfigInput!) {
        createSsoConfig(input: $input) {
            success
            config {
                id
                isRequired
                providerName
                domain
                allowSelfRegistration
                tenantId
                clientId
            }
        }
    }
`;

export const UPDATE_SSO_CONFIG = gql`
    mutation ($input: UpdateSSOConfigInput!) {
        updateSsoConfig(input: $input) {
            success
            config {
                id
                isRequired
                providerName
                domain
                allowSelfRegistration
                tenantId
                clientId
            }
        }
    }
`;

export const DELETE_SSO_CONFIG = gql`
    mutation ($id: UUID!) {
        deleteSsoConfig(id: $id) {
            success
        }
    }
`;

export const UPDATE_MFA_CONFIG = gql`
    mutation ($input: UpdateMfaConfigInput!) {
        updateMfaConfig(input: $input) {
            success
        }
    }
`;

export const UPDATE_SAML_CONFIG = gql`
    mutation ($input: UpdateSAMLConfigInput!) {
        updateSamlConfig(input: $input) {
            success
            config {
                id
                isRequired
                domain
                allowSelfRegistration
                idpEntityId
                idpSsoUrl
                idpSloUrl
                spEntityId
                spNameIdFormat
                attributeMapping
                wantAssertionsSigned
                wantMessageSigned
                metadataUrl
                acsUrl
            }
        }
    }
`;

export const GET_API_INTEGRATIONS = gql`
    query {
        apiIntegrations {
            id
            name
            createdAt
            updatedAt
            orderChannels {
                id
                name
            }
            orderConfirmationChannels {
                id
                name
            }
            invoiceChannels {
                id
                name
            }
            rfqChannels {
                id
                name
            }
            deliveryNoteChannels {
                id
                name
            }
            listOfServicesChannels {
                id
                name
            }
            universalChannels {
                id
                name
            }
            expiresAt
            allChannels
        }
    }
`;

export const CREATE_API_INTEGRATION = gql`
    mutation CreateApiIntegration(
        $name: String!
        $expiresAt: DateTime
        $allChannels: Boolean
        $orderChannels: [UUID]
        $orderConfirmationChannels: [UUID]
        $invoiceChannels: [UUID]
        $rfqChannels: [UUID]
        $deliveryNoteChannels: [UUID]
        $listOfServicesChannels: [UUID]
        $universalChannels: [UUID]
    ) {
        createApiIntegration(
            name: $name
            expiresAt: $expiresAt
            allChannels: $allChannels
            orderChannels: $orderChannels
            orderConfirmationChannels: $orderConfirmationChannels
            invoiceChannels: $invoiceChannels
            rfqChannels: $rfqChannels
            deliveryNoteChannels: $deliveryNoteChannels
            listOfServicesChannels: $listOfServicesChannels
            universalChannels: $universalChannels
        ) {
            success
            apiIntegration {
                id
                name
                createdAt
                updatedAt
                expiresAt
                allChannels
                key
                orderChannels {
                    id
                    name
                }
                orderConfirmationChannels {
                    id
                    name
                }
                invoiceChannels {
                    id
                    name
                }
                rfqChannels {
                    id
                    name
                }
                deliveryNoteChannels {
                    id
                    name
                }
                listOfServicesChannels {
                    id
                    name
                }
                universalChannels {
                    id
                    name
                }
            }
        }
    }
`;

export const UPDATE_API_INTEGRATION = gql`
    mutation UpdateApiIntegration(
        $apiIntegrationId: UUID!
        $name: String
        $expiresAt: DateTime
        $allChannels: Boolean
        $orderChannels: [UUID]
        $orderConfirmationChannels: [UUID]
        $invoiceChannels: [UUID]
        $rfqChannels: [UUID]
        $deliveryNoteChannels: [UUID]
        $listOfServicesChannels: [UUID]
        $universalChannels: [UUID]
    ) {
        updateApiIntegration(
            apiIntegrationId: $apiIntegrationId
            name: $name
            expiresAt: $expiresAt
            allChannels: $allChannels
            orderChannels: $orderChannels
            orderConfirmationChannels: $orderConfirmationChannels
            invoiceChannels: $invoiceChannels
            rfqChannels: $rfqChannels
            deliveryNoteChannels: $deliveryNoteChannels
            listOfServicesChannels: $listOfServicesChannels
            universalChannels: $universalChannels
        ) {
            success
            apiIntegration {
                id
                name
                createdAt
                updatedAt
                expiresAt
                allChannels
                orderChannels {
                    id
                    name
                }
                orderConfirmationChannels {
                    id
                    name
                }
                invoiceChannels {
                    id
                    name
                }
                rfqChannels {
                    id
                    name
                }
                deliveryNoteChannels {
                    id
                    name
                }
                listOfServicesChannels {
                    id
                    name
                }
                universalChannels {
                    id
                    name
                }
            }
        }
    }
`;

export const DELETE_API_INTEGRATION = gql`
    mutation DeleteApiIntegration($apiIntegrationId: UUID!) {
        deleteApiIntegration(apiIntegrationId: $apiIntegrationId) {
            success
        }
    }
`;

export const REFRESH_API_INTEGRATION = gql`
    mutation RefreshApiIntegration($apiIntegrationId: UUID!) {
        refreshApiIntegration(apiIntegrationId: $apiIntegrationId) {
            success
            apiIntegration {
                id
                name
                createdAt
                updatedAt
                expiresAt
                allChannels
                key
                orderChannels {
                    id
                    name
                }
                orderConfirmationChannels {
                    id
                    name
                }
                invoiceChannels {
                    id
                    name
                }
                rfqChannels {
                    id
                    name
                }
                deliveryNoteChannels {
                    id
                    name
                }
                listOfServicesChannels {
                    id
                    name
                }
                universalChannels {
                    id
                    name
                }
            }
        }
    }
`;

export const GET_SFTP_PUBLIC_KEYS = gql`
    query {
        viewer {
            id
            customer {
                shortName
                sftpPublicKeys {
                    DateImported
                    SshPublicKeyBody
                    SshPublicKeyId
                }
            }
        }
    }
`;

export const CREATE_CUSTOMER_SFTP_PUBLIC_KEY = gql`
    mutation ($publicKeyBody: String!) {
        createSftpPublicKey(publicKeyBody: $publicKeyBody) {
            success
        }
    }
`;

export const DELETE_CUSTOMER_SFTP_PUBLIC_KEY = gql`
    mutation ($publicKeyId: String!) {
        deleteSftpPublicKey(publicKeyId: $publicKeyId) {
            success
        }
    }
`;

export const GET_OUTLOOK_ADDINS = gql`
    query outlookAddins {
        outlookAddins {
            id
            createdAt
            name
            createdAt
            updatedAt
            version
            channelMode
            orderChannels {
                id
                name
            }
            invoiceChannels {
                id
                name
            }
            orderConfirmationChannels {
                id
                name
            }
            rfqChannels {
                id
                name
            }
            deliveryNoteChannels {
                id
                name
            }
        }
    }
`;

export const CREATE_OUTLOOK_ADDIN = gql`
    mutation CreateOutlookAddIn(
        $name: String!
        $channelMode: String
        $orderChannels: [UUID]
        $invoiceChannels: [UUID]
        $orderConfirmationChannels: [UUID]
        $rfqChannels: [UUID]
        $deliveryNoteChannels: [UUID]
        $agentId: UUID
    ) {
        createOutlookAddIn(
            name: $name
            channelMode: $channelMode
            orderChannels: $orderChannels
            invoiceChannels: $invoiceChannels
            orderConfirmationChannels: $orderConfirmationChannels
            rfqChannels: $rfqChannels
            deliveryNoteChannels: $deliveryNoteChannels
            agentId: $agentId
        ) {
            addin {
                id
                name
                orderChannels {
                    id
                    name
                }
                invoiceChannels {
                    id
                    name
                }
                orderConfirmationChannels {
                    id
                    name
                }
                rfqChannels {
                    id
                    name
                }
                deliveryNoteChannels {
                    id
                    name
                }
            }
        }
    }
`;

export const DELETE_OUTLOOK_ADDIN = gql`
    mutation DeleteOutlookAddIn($id: UUID!) {
        deleteOutlookAddIn(id: $id) {
            success
        }
    }
`;

export const UPDATE_OUTLOOK_ADDIN = gql`
    mutation UpdateOutlookAddIn(
        $id: UUID!
        $name: String
        $channelMode: String
        $orderChannels: [UUID]
        $invoiceChannels: [UUID]
        $orderConfirmationChannels: [UUID]
        $rfqChannels: [UUID]
        $deliveryNoteChannels: [UUID]
    ) {
        updateOutlookAddIn(
            id: $id
            name: $name
            channelMode: $channelMode
            orderChannels: $orderChannels
            invoiceChannels: $invoiceChannels
            orderConfirmationChannels: $orderConfirmationChannels
            rfqChannels: $rfqChannels
            deliveryNoteChannels: $deliveryNoteChannels
        ) {
            addin {
                id
                name
                orderChannels {
                    id
                    name
                }
                invoiceChannels {
                    id
                    name
                }
                orderConfirmationChannels {
                    id
                    name
                }
                rfqChannels {
                    id
                    name
                }
                deliveryNoteChannels {
                    id
                    name
                }
            }
        }
    }
`;

export const CREATE_WECLAPP_INTEGRATION = gql`
    mutation CreateWeclappIntegration(
        $name: String!
        $orderChannels: [UUID]
        $apiKey: String!
        $tenant: String!
        $workistTicketCategoryId: String!
        $workistImportTicketStatusIds: String!
        $workistInProgressTicketStatusId: String!
        $workistFinishedTicketStatusId: String!
        $workistFinishedTicketCategoryId: String!
    ) {
        createWeclappIntegration(
            name: $name
            orderChannels: $orderChannels
            apiKey: $apiKey
            tenant: $tenant
            workistTicketCategoryId: $workistTicketCategoryId
            workistImportTicketStatusIds: $workistImportTicketStatusIds
            workistInProgressTicketStatusId: $workistInProgressTicketStatusId
            workistFinishedTicketStatusId: $workistFinishedTicketStatusId
            workistFinishedTicketCategoryId: $workistFinishedTicketCategoryId
        ) {
            integration {
                id
                name
                tenant
                workistTicketCategoryId
                workistImportTicketStatusIds
                workistInProgressTicketStatusId
                workistFinishedTicketStatusId
                workistFinishedTicketCategoryId
                orderChannels {
                    id
                    name
                }
            }
        }
    }
`;

export const DELETE_WECLAPP_INTEGRATION = gql`
    mutation DeleteWeclappIntegration($id: UUID!) {
        deleteWeclappIntegration(id: $id) {
            success
        }
    }
`;

export const TRIGGER_WECLAPP_INTEGRATION_MASTERDATA_UPDATE = gql`
    mutation TriggerWeclappIntegrationMasterDataUpdate($id: UUID!) {
        triggerWeclappIntegrationMasterDataUpdate(id: $id) {
            started
        }
    }
`;

export const UPDATE_WECLAPP_INTEGRATION = gql`
    mutation UpdateWeclappIntegration(
        $id: UUID!
        $name: String!
        $orderChannels: [UUID]
        $apiKey: String!
        $tenant: String!
        $workistTicketCategoryId: String!
        $workistImportTicketStatusIds: String!
        $workistInProgressTicketStatusId: String!
        $workistFinishedTicketStatusId: String!
        $workistFinishedTicketCategoryId: String!
    ) {
        updateWeclappIntegration(
            id: $id
            name: $name
            orderChannels: $orderChannels
            apiKey: $apiKey
            tenant: $tenant
            workistTicketCategoryId: $workistTicketCategoryId
            workistImportTicketStatusIds: $workistImportTicketStatusIds
            workistInProgressTicketStatusId: $workistInProgressTicketStatusId
            workistFinishedTicketStatusId: $workistFinishedTicketStatusId
            workistFinishedTicketCategoryId: $workistFinishedTicketCategoryId
        ) {
            integration {
                id
                name
                tenant
                workistTicketCategoryId
                workistImportTicketStatusIds
                workistInProgressTicketStatusId
                workistFinishedTicketStatusId
                workistFinishedTicketCategoryId
                orderChannels {
                    id
                    name
                }
            }
        }
    }
`;

export const GET_WECLAPP_INTEGRATIONS = gql`
    query weclappIntegrations {
        weclappIntegrations {
            id
            createdAt
            name
            tenant
            workistTicketCategoryId
            workistImportTicketStatusIds
            workistInProgressTicketStatusId
            workistFinishedTicketStatusId
            workistFinishedTicketCategoryId
            activeMasterDataUpdate
            lastMasterDataUpdate
            orderChannels {
                id
                name
            }
        }
    }
`;

export const CREATE_SAGE100_INTEGRATION = gql`
    mutation CreateSage100Integration(
        $name: String!
        $orderChannels: [UUID]
        $rfqChannels: [UUID]
        $entitlementId: String!
        $salesOrderType: String!
        $dataSet: String!
        $authFlow: String
    ) {
        createSage100Integration(
            name: $name
            orderChannels: $orderChannels
            rfqChannels: $rfqChannels
            entitlementId: $entitlementId
            salesOrderType: $salesOrderType
            dataSet: $dataSet
            authFlow: $authFlow
        ) {
            redirectUrl
        }
    }
`;

export const DELETE_SAGE100_INTEGRATION = gql`
    mutation DeleteSage100Integration($id: UUID!) {
        deleteSage100Integration(id: $id) {
            success
        }
    }
`;

export const TRIGGER_SAGE100_INTEGRATION_MASTERDATA_UPDATE = gql`
    mutation TriggerSage100IntegrationMasterDataUpdate($id: UUID!) {
        triggerSage100IntegrationMasterDataUpdate(id: $id) {
            started
        }
    }
`;

export const CHECK_SAGE100_INTEGRATION_CONNECTION = gql`
    mutation CheckSage100IntegrationConnection($id: UUID!) {
        checkSage100IntegrationConnection(id: $id) {
            connected
            message
        }
    }
`;

export const TRIGGER_SAGE100_OAUTH_FLOW = gql`
    mutation TriggerSage100OauthFlow($id: UUID!) {
        triggerSage100OauthFlow(id: $id) {
            redirectUrl
        }
    }
`;

export const INTEGRATIONS_SAGE100_OAUTH2_COMPLETE = gql`
    mutation TriggerSage100OauthFlowCompleteMutation($input: OAuthCompleteInput!) {
        triggerSage100OauthFlowComplete(input: $input) {
            success
        }
    }
`;

export const UPDATE_SAGE100_INTEGRATION = gql`
    mutation UpdateSage100Integration(
        $id: UUID!
        $name: String!
        $orderChannels: [UUID]
        $rfqChannels: [UUID]
        $entitlementId: String!
        $salesOrderType: String!
        $offerDocumentType: String
        $dataSet: String!
        $authFlow: String
        $apiVersion: String
        $livePriceCheck: Boolean
        $priceCheckBasis: String
        $allowAgenticWrites: Boolean
        $saveDocumentsAsDrafts: Boolean
        $standardPriceList: String
        $ignoreExpiredOffers: Boolean
        $useOutputMapping: Boolean
    ) {
        updateSage100Integration(
            id: $id
            name: $name
            orderChannels: $orderChannels
            rfqChannels: $rfqChannels
            entitlementId: $entitlementId
            salesOrderType: $salesOrderType
            offerDocumentType: $offerDocumentType
            dataSet: $dataSet
            authFlow: $authFlow
            apiVersion: $apiVersion
            livePriceCheck: $livePriceCheck
            priceCheckBasis: $priceCheckBasis
            allowAgenticWrites: $allowAgenticWrites
            saveDocumentsAsDrafts: $saveDocumentsAsDrafts
            standardPriceList: $standardPriceList
            ignoreExpiredOffers: $ignoreExpiredOffers
            useOutputMapping: $useOutputMapping
        ) {
            integration {
                id
                name
                entitlementId
                salesOrderType
                offerDocumentType
                dataSet
                authFlow
                apiVersion
                livePriceCheck
                priceCheckBasis
                allowAgenticWrites
                saveDocumentsAsDrafts
                standardPriceList
                ignoreExpiredOffers
                useOutputMapping
                fetchProgress
                orderChannels {
                    id
                    name
                }
                rfqChannels {
                    id
                    name
                }
            }
        }
    }
`;

export const GET_SAGE100_PRICE_LISTS = gql`
    query Sage100PriceLists($integrationId: UUID!) {
        sage100PriceLists(integrationId: $integrationId) {
            id
            name
            grossPrices
        }
    }
`;

export const GET_SAGE100_INTEGRATIONS = gql`
    query Sage100Integrations {
        sage100Integrations {
            id
            createdAt
            name
            authState
            authFlow
            entitlementId
            salesOrderType
            offerDocumentType
            dataSet
            apiVersion
            livePriceCheck
            priceCheckBasis
            allowAgenticWrites
            saveDocumentsAsDrafts
            standardPriceList
            ignoreExpiredOffers
            useOutputMapping
            outputMappingSaved
            masterDataUpdatedAt
            masterDataUpdateError
            masterDataUpdateActive
            fetchProgress
            orderChannels {
                id
                name
            }
            rfqChannels {
                id
                name
            }
        }
    }
`;

export const GET_SAGE100_IMPORT_PROGRESS = gql`
    query Sage100ImportProgress {
        sage100Integrations {
            id
            importProgress {
                recordType
                state
                read
                total
                processed
                lastProcessed
                progress
                error
            }
        }
    }
`;

export const CREATE_MICROTECH_BUERO_PLUS_INTEGRATION = gql`
    mutation CreateMicrotechBueroPlusIntegration(
        $name: String!
        $baseUrl: String!
        $clientId: String!
        $clientSecret: String!
        $orderChannels: [UUID]
        $rfqChannels: [UUID]
        $orderTransactionType: String
        $rfqTransactionType: String
        $offerErpSyncTransactionType: String
        $orderDocumentSysArt: String
        $rfqDocumentSysArt: String
    ) {
        createMicrotechBueroPlusIntegration(
            name: $name
            baseUrl: $baseUrl
            clientId: $clientId
            clientSecret: $clientSecret
            orderChannels: $orderChannels
            rfqChannels: $rfqChannels
            orderTransactionType: $orderTransactionType
            rfqTransactionType: $rfqTransactionType
            offerErpSyncTransactionType: $offerErpSyncTransactionType
            orderDocumentSysArt: $orderDocumentSysArt
            rfqDocumentSysArt: $rfqDocumentSysArt
        ) {
            integration {
                id
                authState
            }
        }
    }
`;

export const UPDATE_MICROTECH_BUERO_PLUS_INTEGRATION = gql`
    mutation UpdateMicrotechBueroPlusIntegration(
        $id: UUID!
        $name: String
        $baseUrl: String
        $clientId: String
        $clientSecret: String
        $orderChannels: [UUID]
        $rfqChannels: [UUID]
        $orderTransactionType: String
        $rfqTransactionType: String
        $offerErpSyncTransactionType: String
        $orderDocumentSysArt: String
        $rfqDocumentSysArt: String
    ) {
        updateMicrotechBueroPlusIntegration(
            id: $id
            name: $name
            baseUrl: $baseUrl
            clientId: $clientId
            clientSecret: $clientSecret
            orderChannels: $orderChannels
            rfqChannels: $rfqChannels
            orderTransactionType: $orderTransactionType
            rfqTransactionType: $rfqTransactionType
            offerErpSyncTransactionType: $offerErpSyncTransactionType
            orderDocumentSysArt: $orderDocumentSysArt
            rfqDocumentSysArt: $rfqDocumentSysArt
        ) {
            integration {
                id
                name
                baseUrl
                authState
                orderTransactionType
                rfqTransactionType
                offerErpSyncTransactionType
                orderDocumentSysArt
                rfqDocumentSysArt
                orderChannels {
                    id
                    name
                }
                rfqChannels {
                    id
                    name
                }
            }
        }
    }
`;

export const DELETE_MICROTECH_BUERO_PLUS_INTEGRATION = gql`
    mutation DeleteMicrotechBueroPlusIntegration($id: UUID!) {
        deleteMicrotechBueroPlusIntegration(id: $id) {
            success
        }
    }
`;

export const TRIGGER_MICROTECH_BUERO_PLUS_INTEGRATION_MASTERDATA_UPDATE = gql`
    mutation TriggerMicrotechBueroPlusIntegrationMasterDataUpdate($id: UUID!) {
        triggerMicrotechBueroPlusIntegrationMasterDataUpdate(id: $id) {
            started
        }
    }
`;

export const GET_MICROTECH_BUERO_PLUS_INTEGRATIONS = gql`
    query MicrotechBueroPlusIntegrations {
        microtechBueroPlusIntegrations {
            id
            createdAt
            name
            authState
            baseUrl
            orderTransactionType
            rfqTransactionType
            offerErpSyncTransactionType
            orderDocumentSysArt
            rfqDocumentSysArt
            masterDataUpdateActive
            masterDataUpdatedAt
            masterDataUpdateError
            fetchProgress
            orderChannels {
                id
                name
            }
            rfqChannels {
                id
                name
            }
        }
    }
`;

const DYNAMICS_FINANCE_OPERATIONS_INTEGRATION_FRAGMENT = gql`
    fragment DynamicsFinanceOperationsIntegrationFields on DynamicsFinanceOperationsIntegrationType {
        id
        createdAt
        name
        tenantId
        environment
        apiDataUrl
        additionalHeaders {
            name
            value
        }
        clientId
        dataAreaId
        masterDataUpdatedAt
        masterDataUpdateError
        masterDataUpdateActive
        fetchProgress
        onlyImportStockedArticles
        requireValidUnits
        revertOrderOnAttachmentFailure
        rollbackOrderOnPushFailure
        articlesHaveMultipleVersions
        syncSalesQuotationsAsOffers
        referenceQuotationOnSalesOrder
        syncSalesAgreementsAsFrameworkContracts
        disableMasterDataTransfer
        salesOrderEntityVersion
        stopSalesProcessing
        orderTakerPersonnelNumber
        retailChannelTable
        orderChannels {
            id
            name
        }
        rfqChannels {
            id
            name
        }
    }
`;

export const CREATE_DYNAMICS_FINANCE_OPERATIONS_INTEGRATION = gql`
    mutation CreateDynamicsFinanceOperationsIntegration(
        $name: String!
        $orderChannels: [UUID]
        $rfqChannels: [UUID]
        $tenantId: String!
        $environment: String!
        $apiDataUrl: String
        $additionalHeaders: [DynamicsFinanceOperationsHeaderInput!]
        $clientId: String!
        $clientSecret: String!
        $dataAreaId: String!
        $onlyImportStockedArticles: Boolean
        $requireValidUnits: Boolean
        $revertOrderOnAttachmentFailure: Boolean
        $rollbackOrderOnPushFailure: Boolean
        $articlesHaveMultipleVersions: Boolean
        $syncSalesQuotationsAsOffers: Boolean
        $referenceQuotationOnSalesOrder: Boolean
        $syncSalesAgreementsAsFrameworkContracts: Boolean
        $disableMasterDataTransfer: Boolean
        $salesOrderEntityVersion: String
        $stopSalesProcessing: Boolean
        $orderTakerPersonnelNumber: String
        $retailChannelTable: BigInt
    ) {
        createDynamicsFinanceOperationsIntegration(
            name: $name
            orderChannels: $orderChannels
            rfqChannels: $rfqChannels
            tenantId: $tenantId
            environment: $environment
            apiDataUrl: $apiDataUrl
            additionalHeaders: $additionalHeaders
            clientId: $clientId
            clientSecret: $clientSecret
            dataAreaId: $dataAreaId
            onlyImportStockedArticles: $onlyImportStockedArticles
            requireValidUnits: $requireValidUnits
            revertOrderOnAttachmentFailure: $revertOrderOnAttachmentFailure
            rollbackOrderOnPushFailure: $rollbackOrderOnPushFailure
            articlesHaveMultipleVersions: $articlesHaveMultipleVersions
            syncSalesQuotationsAsOffers: $syncSalesQuotationsAsOffers
            referenceQuotationOnSalesOrder: $referenceQuotationOnSalesOrder
            syncSalesAgreementsAsFrameworkContracts: $syncSalesAgreementsAsFrameworkContracts
            disableMasterDataTransfer: $disableMasterDataTransfer
            salesOrderEntityVersion: $salesOrderEntityVersion
            stopSalesProcessing: $stopSalesProcessing
            orderTakerPersonnelNumber: $orderTakerPersonnelNumber
            retailChannelTable: $retailChannelTable
        ) {
            integration {
                ...DynamicsFinanceOperationsIntegrationFields
            }
        }
    }
    ${DYNAMICS_FINANCE_OPERATIONS_INTEGRATION_FRAGMENT}
`;

export const DELETE_DYNAMICS_FINANCE_OPERATIONS_INTEGRATION = gql`
    mutation DeleteDynamicsFinanceOperationsIntegration($id: UUID!) {
        deleteDynamicsFinanceOperationsIntegration(id: $id) {
            success
        }
    }
`;

export const TRIGGER_DYNAMICS_FINANCE_OPERATIONS_INTEGRATION_MASTERDATA_UPDATE = gql`
    mutation TriggerDynamicsFinanceOperationsIntegrationMasterDataUpdate($id: UUID!) {
        triggerDynamicsFinanceOperationsIntegrationMasterDataUpdate(id: $id) {
            started
        }
    }
`;

export const CHECK_DYNAMICS_FINANCE_OPERATIONS_INTEGRATION_CONNECTION = gql`
    mutation CheckDynamicsFinanceOperationsIntegrationConnection($id: UUID!) {
        checkDynamicsFinanceOperationsIntegrationConnection(id: $id) {
            connected
            message
        }
    }
`;

export const UPDATE_DYNAMICS_FINANCE_OPERATIONS_INTEGRATION = gql`
    mutation UpdateDynamicsFinanceOperationsIntegration(
        $id: UUID!
        $name: String!
        $orderChannels: [UUID]
        $rfqChannels: [UUID]
        $tenantId: String!
        $environment: String!
        $apiDataUrl: String
        $additionalHeaders: [DynamicsFinanceOperationsHeaderInput!]
        $clientId: String!
        $clientSecret: String!
        $dataAreaId: String!
        $onlyImportStockedArticles: Boolean
        $requireValidUnits: Boolean
        $revertOrderOnAttachmentFailure: Boolean
        $rollbackOrderOnPushFailure: Boolean
        $articlesHaveMultipleVersions: Boolean
        $syncSalesQuotationsAsOffers: Boolean
        $referenceQuotationOnSalesOrder: Boolean
        $syncSalesAgreementsAsFrameworkContracts: Boolean
        $disableMasterDataTransfer: Boolean
        $salesOrderEntityVersion: String
        $stopSalesProcessing: Boolean
        $orderTakerPersonnelNumber: String
        $retailChannelTable: BigInt
    ) {
        updateDynamicsFinanceOperationsIntegration(
            id: $id
            name: $name
            orderChannels: $orderChannels
            rfqChannels: $rfqChannels
            tenantId: $tenantId
            environment: $environment
            apiDataUrl: $apiDataUrl
            additionalHeaders: $additionalHeaders
            clientId: $clientId
            clientSecret: $clientSecret
            dataAreaId: $dataAreaId
            onlyImportStockedArticles: $onlyImportStockedArticles
            requireValidUnits: $requireValidUnits
            revertOrderOnAttachmentFailure: $revertOrderOnAttachmentFailure
            rollbackOrderOnPushFailure: $rollbackOrderOnPushFailure
            articlesHaveMultipleVersions: $articlesHaveMultipleVersions
            syncSalesQuotationsAsOffers: $syncSalesQuotationsAsOffers
            referenceQuotationOnSalesOrder: $referenceQuotationOnSalesOrder
            syncSalesAgreementsAsFrameworkContracts: $syncSalesAgreementsAsFrameworkContracts
            disableMasterDataTransfer: $disableMasterDataTransfer
            salesOrderEntityVersion: $salesOrderEntityVersion
            stopSalesProcessing: $stopSalesProcessing
            orderTakerPersonnelNumber: $orderTakerPersonnelNumber
            retailChannelTable: $retailChannelTable
        ) {
            integration {
                ...DynamicsFinanceOperationsIntegrationFields
            }
        }
    }
    ${DYNAMICS_FINANCE_OPERATIONS_INTEGRATION_FRAGMENT}
`;

export const GET_DYNAMICS_FINANCE_OPERATIONS_INTEGRATIONS = gql`
    query DynamicsFinanceOperationsIntegrations {
        dynamicsFinanceOperationsIntegrations {
            ...DynamicsFinanceOperationsIntegrationFields
        }
    }
    ${DYNAMICS_FINANCE_OPERATIONS_INTEGRATION_FRAGMENT}
`;

const NETSUITE_INTEGRATION_FRAGMENT = gql`
    fragment NetsuiteIntegrationFields on NetsuiteIntegrationType {
        id
        name
        clientId
        tokenId
        accountId
        instanceUrl
        restServiceUrl
        createdAt
        fetchProgress
        masterDataUpdatedAt
        masterDataUpdateError
        masterDataUpdateActive
        orderFileCabinetFolderId
        orderCustomFormId
        orderChannels {
            id
            name
        }
        rfqCustomFormId
        rfqFileCabinetFolderId
        rfqChannels {
            id
            name
        }
        universalFileCabinetFolderId
        universalChannels {
            id
            name
        }
        masterDataMode
        invoiceCustomFormId
        invoiceFileCabinetFolderId
        invoiceChannels {
            id
            name
        }
        defaultApprovalStatus
        defaultExpenseAccountId
        defaultSubsidiaryId
        defaultLocationId
        useAltaviaMapping
        altaviaRestletUrl
    }
`;

export const CREATE_NETSUITE_INTEGRATION = gql`
    mutation CreateNetsuiteIntegration(
        $name: String!
        $orderChannels: [UUID]
        $clientId: String!
        $clientSecret: String!
        $tokenId: String!
        $tokenSecret: String!
        $accountId: String!
        $restServiceUrl: String!
        $instanceUrl: String
        $orderFileCabinetFolderId: String
        $orderCustomFormId: String
        $rfqCustomFormId: String
        $rfqFileCabinetFolderId: String
        $rfqChannels: [UUID]
        $universalFileCabinetFolderId: String
        $universalChannels: [UUID]
        $masterDataMode: String
        $invoiceCustomFormId: String
        $invoiceFileCabinetFolderId: String
        $invoiceChannels: [UUID]
        $defaultApprovalStatus: String
        $defaultExpenseAccountId: String
        $defaultSubsidiaryId: String
        $defaultLocationId: String
        $useAltaviaMapping: Boolean
        $altaviaRestletUrl: String
    ) {
        createNetsuiteIntegration(
            name: $name
            orderChannels: $orderChannels
            clientId: $clientId
            clientSecret: $clientSecret
            tokenId: $tokenId
            tokenSecret: $tokenSecret
            accountId: $accountId
            instanceUrl: $instanceUrl
            restServiceUrl: $restServiceUrl
            orderFileCabinetFolderId: $orderFileCabinetFolderId
            orderCustomFormId: $orderCustomFormId
            rfqCustomFormId: $rfqCustomFormId
            rfqFileCabinetFolderId: $rfqFileCabinetFolderId
            rfqChannels: $rfqChannels
            universalFileCabinetFolderId: $universalFileCabinetFolderId
            universalChannels: $universalChannels
            masterDataMode: $masterDataMode
            invoiceCustomFormId: $invoiceCustomFormId
            invoiceFileCabinetFolderId: $invoiceFileCabinetFolderId
            invoiceChannels: $invoiceChannels
            defaultApprovalStatus: $defaultApprovalStatus
            defaultExpenseAccountId: $defaultExpenseAccountId
            defaultSubsidiaryId: $defaultSubsidiaryId
            defaultLocationId: $defaultLocationId
            useAltaviaMapping: $useAltaviaMapping
            altaviaRestletUrl: $altaviaRestletUrl
        ) {
            integration {
                ...NetsuiteIntegrationFields
            }
        }
    }
    ${NETSUITE_INTEGRATION_FRAGMENT}
`;

export const DELETE_NETSUITE_INTEGRATION = gql`
    mutation DeleteNetsuiteIntegration($id: UUID!) {
        deleteNetsuiteIntegration(id: $id) {
            success
        }
    }
`;

export const TRIGGER_NETSUITE_INTEGRATION_MASTERDATA_UPDATE = gql`
    mutation TriggerNetsuiteIntegrationMasterDataUpdate($id: UUID!) {
        triggerNetsuiteIntegrationMasterDataUpdate(id: $id) {
            started
        }
    }
`;

export const UPDATE_NETSUITE_INTEGRATION = gql`
    mutation UpdateNetsuiteIntegration(
        $id: UUID!
        $name: String!
        $orderChannels: [UUID]
        $clientId: String!
        $clientSecret: String!
        $tokenId: String!
        $tokenSecret: String!
        $accountId: String!
        $instanceUrl: String!
        $restServiceUrl: String!
        $orderFileCabinetFolderId: String
        $orderCustomFormId: String
        $rfqCustomFormId: String
        $rfqFileCabinetFolderId: String
        $rfqChannels: [UUID]
        $universalFileCabinetFolderId: String
        $universalChannels: [UUID]
        $masterDataMode: String
        $invoiceCustomFormId: String
        $invoiceFileCabinetFolderId: String
        $invoiceChannels: [UUID]
        $defaultApprovalStatus: String
        $defaultExpenseAccountId: String
        $defaultSubsidiaryId: String
        $defaultLocationId: String
        $useAltaviaMapping: Boolean
        $altaviaRestletUrl: String
    ) {
        updateNetsuiteIntegration(
            id: $id
            name: $name
            orderChannels: $orderChannels
            clientId: $clientId
            clientSecret: $clientSecret
            tokenId: $tokenId
            tokenSecret: $tokenSecret
            accountId: $accountId
            instanceUrl: $instanceUrl
            restServiceUrl: $restServiceUrl
            orderFileCabinetFolderId: $orderFileCabinetFolderId
            orderCustomFormId: $orderCustomFormId
            rfqCustomFormId: $rfqCustomFormId
            rfqFileCabinetFolderId: $rfqFileCabinetFolderId
            rfqChannels: $rfqChannels
            universalFileCabinetFolderId: $universalFileCabinetFolderId
            universalChannels: $universalChannels
            masterDataMode: $masterDataMode
            invoiceCustomFormId: $invoiceCustomFormId
            invoiceFileCabinetFolderId: $invoiceFileCabinetFolderId
            invoiceChannels: $invoiceChannels
            defaultApprovalStatus: $defaultApprovalStatus
            defaultExpenseAccountId: $defaultExpenseAccountId
            defaultSubsidiaryId: $defaultSubsidiaryId
            defaultLocationId: $defaultLocationId
            useAltaviaMapping: $useAltaviaMapping
            altaviaRestletUrl: $altaviaRestletUrl
        ) {
            integration {
                ...NetsuiteIntegrationFields
            }
        }
    }
    ${NETSUITE_INTEGRATION_FRAGMENT}
`;

export const GET_NETSUITE_INTEGRATIONS = gql`
    query NetsuiteIntegrations {
        netsuiteIntegrations {
            ...NetsuiteIntegrationFields
        }
    }
    ${NETSUITE_INTEGRATION_FRAGMENT}
`;

export const CREATE_SAGE200PROFESSIONAL_INTEGRATION = gql`
    mutation CreateSage200ProfessionalIntegration(
        $name: String!
        $orderChannels: [UUID]
        $siteId: String!
        $companyId: String!
        $warehouseId: String!
        $lineTypeId: String!
        $defaultTaxCodeId: String!
    ) {
        createSage200professionalIntegration(
            name: $name
            orderChannels: $orderChannels
            siteId: $siteId
            companyId: $companyId
            warehouseId: $warehouseId
            lineTypeId: $lineTypeId
            defaultTaxCodeId: $defaultTaxCodeId
        ) {
            redirectUrl
        }
    }
`;

export const DELETE_SAGE200PROFESSIONAL_INTEGRATION = gql`
    mutation DeleteSage200ProfessionalIntegration($id: UUID!) {
        deleteSage200professionalIntegration(id: $id) {
            success
        }
    }
`;

export const TRIGGER_SAGE200PROFESSIONAL_INTEGRATION_MASTERDATA_UPDATE = gql`
    mutation TriggerSage200ProfessionalIntegrationMasterDataUpdate($id: UUID!) {
        triggerSage200professionalIntegrationMasterDataUpdate(id: $id) {
            started
        }
    }
`;

export const TRIGGER_SAGE200PROFESSIONAL_OAUTH_FLOW = gql`
    mutation TriggerSage200ProfessionalOauthFlow($id: UUID!) {
        triggerSage200professionalOauthFlow(id: $id) {
            redirectUrl
        }
    }
`;

export const INTEGRATIONS_SAGE200PROFESSIONAL_OAUTH2_COMPLETE = gql`
    mutation TriggerSage200ProfessionalOauthFlowCompleteMutation($input: OAuthCompleteInput!) {
        triggerSage200professionalOauthFlowComplete(input: $input) {
            success
        }
    }
`;

export const UPDATE_SAGE200PROFESSIONAL_INTEGRATION = gql`
    mutation UpdateSage200ProfessionalIntegration(
        $id: UUID!
        $name: String!
        $orderChannels: [UUID]
        $siteId: String!
        $companyId: String!
        $warehouseId: String!
        $lineTypeId: String!
        $defaultTaxCodeId: String!
    ) {
        updateSage200professionalIntegration(
            id: $id
            name: $name
            orderChannels: $orderChannels
            siteId: $siteId
            companyId: $companyId
            warehouseId: $warehouseId
            lineTypeId: $lineTypeId
            defaultTaxCodeId: $defaultTaxCodeId
        ) {
            integration {
                id
                name
                siteId
                companyId
                warehouseId
                lineTypeId
                defaultTaxCodeId
                orderChannels {
                    id
                    name
                }
            }
        }
    }
`;

export const GET_SAGE200PROFESSIONAL_INTEGRATIONS = gql`
    query Sage200ProfessionalIntegrations {
        sage200professionalIntegrations {
            id
            createdAt
            name
            authState
            siteId
            companyId
            warehouseId
            lineTypeId
            defaultTaxCodeId
            activeMasterDataUpdate
            lastMasterDataUpdate
            orderChannels {
                id
                name
            }
        }
    }
`;

const SMART_INBOX_INTEGRATION_BASE_FRAGMENT = gql`
    fragment SmartInboxIntegrationBaseFields on SmartInboxIntegrationType {
        id
        name
        mailInbox
        enabled
    }
`;

const SMART_INBOX_INTEGRATION_DETAIL_FRAGMENT = gql`
    fragment SmartInboxIntegrationDetailFields on SmartInboxIntegrationType {
        ...SmartInboxIntegrationBaseFields
        isManualDocumentCreationEnabled
        ignoreReplyAndForwardedEmails
        useSmartInboxAsCreatedBy
        destinationFolders {
            id
            name
        }
        productConfigs {
            documentType
            channelId
            channelName
            actionConfigs {
                id
                eventKind
                actionKind
                actionConfig
            }
        }
        customCategories {
            id
            name
            detectionCriteria
            supportingKeywords
            enabled
            sourceType
            actions {
                id
                actionKind
                actionConfig
            }
        }
    }
    ${SMART_INBOX_INTEGRATION_BASE_FRAGMENT}
`;

export const GET_SMART_INBOX_INTEGRATIONS = gql`
    query smartInboxIntegrations {
        smartInboxIntegrations {
            ...SmartInboxIntegrationBaseFields
            productConfigs {
                documentType
                channelId
                channelName
            }
            customCategories {
                id
            }
        }
    }
    ${SMART_INBOX_INTEGRATION_BASE_FRAGMENT}
`;

export const GET_SMART_INBOX_INTEGRATION = gql`
    query smartInboxIntegration($id: UUID!) {
        smartInboxIntegration(id: $id) {
            ...SmartInboxIntegrationDetailFields
        }
    }
    ${SMART_INBOX_INTEGRATION_DETAIL_FRAGMENT}
`;

export const RECOMMENDED_CUSTOM_CATEGORIES = gql`
    query RecommendedCustomCategories($integrationId: UUID!) {
        recommendedCustomCategories(integrationId: $integrationId) {
            id
            name
            detectionCriteria
            supportingKeywords
            tag
            tagColor
            sourceType
        }
    }
`;

export const GET_CATEGORY_CATALOG = gql`
    query CategoryCatalog(
        $page: Int
        $perPage: Int
        $search: String
        $automation: [UUID!]
        $status: [String!]
        $mailboxId: [UUID!]
    ) {
        categoryCatalog(
            page: $page
            perPage: $perPage
            search: $search
            automation: $automation
            status: $status
            mailboxId: $mailboxId
        ) {
            items {
                id
                name
                detectionCriteria
                supportingKeywords
                enabled
                sourceType
                actions {
                    id
                    actionKind
                    actionConfig
                }
                mailbox {
                    id
                    mailInbox
                }
            }
            totalCount
        }
    }
`;

export const CREATE_SMART_INBOX_INTEGRATION = gql`
    mutation createSmartInboxIntegration(
        $name: String!
        $channels: [SmartInboxProductConfigInput!]
        $tenantId: String
        $clientId: String
        $clientSecret: String
        $mailInbox: String!
        $isManualDocumentCreationEnabled: Boolean
        $ignoreReplyAndForwardedEmails: Boolean
        $useSmartInboxAsCreatedBy: Boolean
        $enabled: Boolean
    ) {
        createSmartInboxIntegration(
            name: $name
            channels: $channels
            tenantId: $tenantId
            clientId: $clientId
            clientSecret: $clientSecret
            mailInbox: $mailInbox
            isManualDocumentCreationEnabled: $isManualDocumentCreationEnabled
            ignoreReplyAndForwardedEmails: $ignoreReplyAndForwardedEmails
            useSmartInboxAsCreatedBy: $useSmartInboxAsCreatedBy
            enabled: $enabled
        ) {
            success
        }
    }
`;

export const DELETE_SMART_INBOX_INTEGRATION = gql`
    mutation deleteSmartInboxIntegration($id: String!) {
        deleteSmartInboxIntegration(id: $id) {
            success
        }
    }
`;

export const UPDATE_SMART_INBOX_INTEGRATION = gql`
    mutation updateSmartInboxIntegration(
        $id: UUID!
        $name: String!
        $isManualDocumentCreationEnabled: Boolean
        $ignoreReplyAndForwardedEmails: Boolean
        $useSmartInboxAsCreatedBy: Boolean
        $enabled: Boolean
        $productConfigs: [SmartInboxProductConfigInput!]
        $channels: [SmartInboxProductConfigInput!]
    ) {
        updateSmartInboxIntegration(
            id: $id
            name: $name
            isManualDocumentCreationEnabled: $isManualDocumentCreationEnabled
            ignoreReplyAndForwardedEmails: $ignoreReplyAndForwardedEmails
            useSmartInboxAsCreatedBy: $useSmartInboxAsCreatedBy
            enabled: $enabled
            productConfigs: $productConfigs
            channels: $channels
        ) {
            success
        }
    }
`;

export const GET_MAILBOX_CATEGORY_IDS = gql`
    query GetMailboxCategoryIds($id: UUID!) {
        smartInboxIntegration(id: $id) {
            id
            customCategories {
                id
            }
        }
    }
`;

export const CREATE_CUSTOM_CATEGORY = gql`
    mutation CreateCustomCategory(
        $integrationId: UUID!
        $name: String!
        $detectionCriteria: String!
        $supportingKeywords: [String]
        $actions: [CustomCategoryActionInput]
    ) {
        createCustomCategory(
            integrationId: $integrationId
            name: $name
            detectionCriteria: $detectionCriteria
            supportingKeywords: $supportingKeywords
            actions: $actions
        ) {
            success
        }
    }
`;

export const ADD_RECOMMENDED_CATEGORIES = gql`
    mutation AddRecommendedCategories($integrationId: UUID!, $recommendedCategoryIds: [UUID]!) {
        addRecommendedCategories(integrationId: $integrationId, recommendedCategoryIds: $recommendedCategoryIds) {
            success
        }
    }
`;

export const UPDATE_CUSTOM_CATEGORY = gql`
    mutation UpdateCustomCategory(
        $id: UUID!
        $name: String
        $detectionCriteria: String
        $supportingKeywords: [String]
        $enabled: Boolean
        $actions: [CustomCategoryActionInput]
    ) {
        updateCustomCategory(
            id: $id
            name: $name
            detectionCriteria: $detectionCriteria
            supportingKeywords: $supportingKeywords
            enabled: $enabled
            actions: $actions
        ) {
            success
        }
    }
`;

export const REORDER_CUSTOM_CATEGORIES = gql`
    mutation ReorderCustomCategories($integrationId: UUID!, $categoryIds: [UUID]!) {
        reorderCustomCategories(integrationId: $integrationId, categoryIds: $categoryIds) {
            success
        }
    }
`;

export const DELETE_CUSTOM_CATEGORY = gql`
    mutation DeleteCustomCategory($id: UUID!) {
        deleteCustomCategory(id: $id) {
            success
        }
    }
`;

export const GET_BUSINESS_CENTRAL_INTEGRATIONS = gql`
    query businessCentralIntegrations {
        apiIntegrations {
            name
            key
        }

        businessCentralIntegrations {
            id
            createdAt
            name
            businessCentralUrl
            orderChannels {
                id
                name

                masterDataConfig {
                    clientLookupDefinitionId
                    contactLookupDefinitionId
                    clientInternalContactLookupDefinitionId
                    emailLookupDefinitionId

                    articleLookupDefinitionId
                    debitorArticleLookupDefinitionId
                    conversionFactorLookupDefinitionId
                    frameworkContractLookupDefinitionId

                    invoiceAddressLookupDefinitionId
                    deliveryAddressLookupDefinitionId
                }
            }

            orderConfirmationChannels {
                id
                name

                masterDataConfig {
                    clientLookupDefinitionId
                    contactLookupDefinitionId
                    clientInternalContactLookupDefinitionId
                    emailLookupDefinitionId

                    articleLookupDefinitionId
                    debitorArticleLookupDefinitionId
                    conversionFactorLookupDefinitionId
                    frameworkContractLookupDefinitionId

                    invoiceAddressLookupDefinitionId
                    deliveryAddressLookupDefinitionId
                }
            }
        }
    }
`;

export const CREATE_BUSINESS_CENTRAL_INTEGRATION = gql`
    mutation CreateBusinessCentralIntegration(
        $name: String!
        $businessCentralUrl: String
        $orderChannels: [UUID]
        $orderConfirmationChannels: [UUID]
    ) {
        createBusinessCentralIntegration(
            name: $name
            businessCentralUrl: $businessCentralUrl
            orderChannels: $orderChannels
            orderConfirmationChannels: $orderConfirmationChannels
        ) {
            success
        }
    }
`;

export const DELETE_BUSINESS_CENTRAL_INTEGRATION = gql`
    mutation DeleteBusinessCentralIntegration($id: UUID!) {
        deleteBusinessCentralIntegration(id: $id) {
            success
        }
    }
`;

export const UPDATE_BUSINESS_CENTRAL_INTEGRATION = gql`
    mutation UpdateBusinessCentralIntegration(
        $id: UUID!
        $name: String!
        $businessCentralUrl: String
        $orderChannels: [UUID]
        $orderConfirmationChannels: [UUID]
    ) {
        updateBusinessCentralIntegration(
            id: $id
            name: $name
            businessCentralUrl: $businessCentralUrl
            orderChannels: $orderChannels
            orderConfirmationChannels: $orderConfirmationChannels
        ) {
            success
        }
    }
`;

export const CREATE_QUICKBOOKS_INTEGRATION = gql`
    mutation CreateQuickBooksIntegration(
        $name: String!
        $apiKey: String!
        $endUserId: String!
        $orderChannels: [UUID]
        $templateId: String
        $orderTotalItemId: String
        $discountItemId: String
        $customerTotalDiscountCustomField: String
    ) {
        createQuickbooksIntegration(
            name: $name
            apiKey: $apiKey
            endUserId: $endUserId
            orderChannels: $orderChannels
            templateId: $templateId
            orderTotalItemId: $orderTotalItemId
            discountItemId: $discountItemId
            customerTotalDiscountCustomField: $customerTotalDiscountCustomField
        ) {
            integration {
                id
                name
                endUserId
                createdAt
                masterDataUpdatedAt
                masterDataUpdateError
                masterDataUpdateActive
                fetchProgress
                extraData
                templateId
                orderTotalItemId
                discountItemId
                customerTotalDiscountCustomField
                orderChannels {
                    id
                    name
                }
            }
        }
    }
`;

export const DELETE_QUICKBOOKS_INTEGRATION = gql`
    mutation DeleteQuickBooksIntegration($id: UUID!) {
        deleteQuickbooksIntegration(id: $id) {
            success
        }
    }
`;

export const TRIGGER_QUICKBOOKS_INTEGRATION_MASTERDATA_UPDATE = gql`
    mutation TriggerQuickBooksIntegrationMasterDataUpdate($id: UUID!) {
        triggerQuickbooksIntegrationMasterDataUpdate(id: $id) {
            started
        }
    }
`;

export const PERFORM_QUICKBOOKS_INTEGRATION_HEALTH_CHECK = gql`
    mutation performQuickbooksIntegrationHealthCheck($id: UUID!) {
        performQuickbooksIntegrationHealthCheck(id: $id) {
            integration {
                id
                createdAt
                name
                endUserId
                masterDataUpdatedAt
                masterDataUpdateError
                masterDataUpdateActive
                fetchProgress
                extraData
                templateId
                orderTotalItemId
                discountItemId
                customerTotalDiscountCustomField
                connectionStatus
                connectionPingMs
                connectionStatusErrorMessage
                orderChannels {
                    id
                    name
                }
            }
        }
    }
`;

export const UPDATE_QUICKBOOKS_INTEGRATION = gql`
    mutation UpdateQuickBooksIntegration(
        $id: UUID!
        $name: String
        $apiKey: String
        $endUserId: String
        $orderChannels: [UUID]
        $templateId: String
        $orderTotalItemId: String
        $discountItemId: String
        $customerTotalDiscountCustomField: String
    ) {
        updateQuickbooksIntegration(
            id: $id
            name: $name
            apiKey: $apiKey
            endUserId: $endUserId
            orderChannels: $orderChannels
            templateId: $templateId
            orderTotalItemId: $orderTotalItemId
            discountItemId: $discountItemId
            customerTotalDiscountCustomField: $customerTotalDiscountCustomField
        ) {
            integration {
                id
                name
                endUserId
                createdAt
                masterDataUpdatedAt
                masterDataUpdateError
                masterDataUpdateActive
                fetchProgress
                extraData
                templateId
                orderTotalItemId
                discountItemId
                customerTotalDiscountCustomField
                orderChannels {
                    id
                    name
                }
            }
        }
    }
`;

export const GET_QUICKBOOKS_INTEGRATIONS = gql`
    query QuickBooksIntegrations {
        quickbooksIntegrations {
            id
            createdAt
            name
            endUserId
            masterDataUpdatedAt
            masterDataUpdateError
            masterDataUpdateActive
            fetchProgress
            extraData
            templateId
            orderTotalItemId
            discountItemId
            customerTotalDiscountCustomField
            connectionStatus
            connectionPingMs
            connectionStatusErrorMessage
            orderChannels {
                id
                name
            }
        }
    }
`;

// SAP Business One
export const CREATE_SAP_BUSINESS_ONE_INTEGRATION = gql`
    mutation CreateSapBusinessOneIntegration(
        $name: String!
        $companyDb: String!
        $username: String!
        $password: String!
        $maxRecordsPerData: Int
        $restServiceUrl: String!
        $avoidDeliveryDatesInThePast: Boolean
        $itemQuery: String
        $clientQuery: String
        $orderChannels: [UUID]
        $overwriteDefaultShippingMethod: Int
        $bpPropertyForAutomation: String
        $bpNoAutomationNoteText: String
        $calculatePriceOnOrderCreate: Boolean
        $customUnitPriceMasterDataField: String
        $uploadSourceFile: Boolean
        $uploadDocumentTypeField: String
        $uploadDocumentTypeEmail: String
        $uploadDocumentTypeDeliveryNote: String
        $uploadDocumentTypeOrder: String
    ) {
        createSapBusinessOneIntegration(
            name: $name
            companyDb: $companyDb
            username: $username
            password: $password
            maxRecordsPerData: $maxRecordsPerData
            restServiceUrl: $restServiceUrl
            orderChannels: $orderChannels
            avoidDeliveryDatesInThePast: $avoidDeliveryDatesInThePast
            itemQuery: $itemQuery
            clientQuery: $clientQuery
            overwriteDefaultShippingMethod: $overwriteDefaultShippingMethod
            bpNoAutomationNoteText: $bpNoAutomationNoteText
            bpPropertyForAutomation: $bpPropertyForAutomation
            calculatePriceOnOrderCreate: $calculatePriceOnOrderCreate
            customUnitPriceMasterDataField: $customUnitPriceMasterDataField
            uploadSourceFile: $uploadSourceFile
            uploadDocumentTypeField: $uploadDocumentTypeField
            uploadDocumentTypeEmail: $uploadDocumentTypeEmail
            uploadDocumentTypeDeliveryNote: $uploadDocumentTypeDeliveryNote
            uploadDocumentTypeOrder: $uploadDocumentTypeOrder
        ) {
            integration {
                id
                name
                companyDb
                username
                maxRecordsPerData
                restServiceUrl
                createdAt
                masterDataUpdatedAt
                masterDataUpdateError
                masterDataUpdateActive
                avoidDeliveryDatesInThePast
                clientQuery
                itemQuery
                overwriteDefaultShippingMethod
                bpPropertyForAutomation
                bpNoAutomationNoteText
                calculatePriceOnOrderCreate
                customUnitPriceMasterDataField
                uploadSourceFile
                uploadDocumentTypeField
                uploadDocumentTypeEmail
                uploadDocumentTypeDeliveryNote
                uploadDocumentTypeOrder
                orderChannels {
                    id
                    name
                }
            }
        }
    }
`;

export const DELETE_SAP_BUSINESS_ONE_INTEGRATION = gql`
    mutation DeleteSapBusinessOneIntegration($id: UUID!) {
        deleteSapBusinessOneIntegration(id: $id) {
            success
        }
    }
`;

export const TRIGGER_SAP_BUSINESS_ONE_INTEGRATION_MASTERDATA_UPDATE = gql`
    mutation TriggerSapBusinessOneIntegrationMasterDataUpdate($id: UUID!) {
        triggerSapBusinessOneIntegrationMasterDataUpdate(id: $id) {
            started
        }
    }
`;

export const UPDATE_SAP_BUSINESS_ONE_INTEGRATION = gql`
    mutation UpdateSapBusinessOneIntegration(
        $id: UUID!
        $name: String!
        $companyDb: String!
        $username: String!
        $password: String!
        $maxRecordsPerData: Int
        $avoidDeliveryDatesInThePast: Boolean
        $restServiceUrl: String!
        $itemQuery: String
        $clientQuery: String
        $overwriteDefaultShippingMethod: Int
        $orderChannels: [UUID]
        $bpPropertyForAutomation: String
        $bpNoAutomationNoteText: String
        $calculatePriceOnOrderCreate: Boolean
        $customUnitPriceMasterDataField: String
        $uploadSourceFile: Boolean
        $uploadDocumentTypeField: String
        $uploadDocumentTypeEmail: String
        $uploadDocumentTypeDeliveryNote: String
        $uploadDocumentTypeOrder: String
    ) {
        updateSapBusinessOneIntegration(
            id: $id
            name: $name
            companyDb: $companyDb
            username: $username
            password: $password
            maxRecordsPerData: $maxRecordsPerData
            restServiceUrl: $restServiceUrl
            orderChannels: $orderChannels
            itemQuery: $itemQuery
            clientQuery: $clientQuery
            avoidDeliveryDatesInThePast: $avoidDeliveryDatesInThePast
            overwriteDefaultShippingMethod: $overwriteDefaultShippingMethod
            bpPropertyForAutomation: $bpPropertyForAutomation
            bpNoAutomationNoteText: $bpNoAutomationNoteText
            calculatePriceOnOrderCreate: $calculatePriceOnOrderCreate
            customUnitPriceMasterDataField: $customUnitPriceMasterDataField
            uploadSourceFile: $uploadSourceFile
            uploadDocumentTypeField: $uploadDocumentTypeField
            uploadDocumentTypeEmail: $uploadDocumentTypeEmail
            uploadDocumentTypeDeliveryNote: $uploadDocumentTypeDeliveryNote
            uploadDocumentTypeOrder: $uploadDocumentTypeOrder
        ) {
            integration {
                id
                name
                companyDb
                username
                maxRecordsPerData
                restServiceUrl
                createdAt
                masterDataUpdatedAt
                masterDataUpdateError
                masterDataUpdateActive
                avoidDeliveryDatesInThePast
                clientQuery
                itemQuery
                overwriteDefaultShippingMethod
                bpPropertyForAutomation
                bpNoAutomationNoteText
                calculatePriceOnOrderCreate
                customUnitPriceMasterDataField
                uploadSourceFile
                uploadDocumentTypeField
                uploadDocumentTypeEmail
                uploadDocumentTypeDeliveryNote
                uploadDocumentTypeOrder
                orderChannels {
                    id
                    name
                }
            }
        }
    }
`;

export const GET_SAP_BUSINESS_ONE_INTEGRATIONS = gql`
    query SapBusinessOneIntegrations {
        sapBusinessOneIntegrations {
            id
            name
            companyDb
            username
            maxRecordsPerData
            restServiceUrl
            createdAt
            masterDataUpdatedAt
            masterDataUpdateError
            masterDataUpdateActive
            fetchProgress
            avoidDeliveryDatesInThePast
            clientQuery
            itemQuery
            overwriteDefaultShippingMethod
            bpPropertyForAutomation
            bpNoAutomationNoteText
            calculatePriceOnOrderCreate
            customUnitPriceMasterDataField
            uploadSourceFile
            uploadDocumentTypeField
            uploadDocumentTypeEmail
            uploadDocumentTypeDeliveryNote
            uploadDocumentTypeOrder
            orderChannels {
                id
                name
            }
        }
    }
`;

// Custom Integration

const CUSTOM_INTEGRATION_FRAGMENT = gql`
    fragment CustomIntegrationFields on CustomIntegrationType {
        id
        name
        enabled
        config
        authState
        baseUrl
        authId
        authToken
        extraData
        fetchProgress
        masterDataUpdateActive
        masterDataUpdatedAt
        masterDataUpdateError
        excludedRecordTypes
        createdAt
        updatedAt
        createdBy {
            id
            firstName
            lastName
            email
        }
        orderChannels {
            id
            name
        }
        rfqChannels {
            id
            name
        }
    }
`;

export const GET_CUSTOM_INTEGRATIONS = gql`
    query CustomIntegrations {
        customIntegrations {
            ...CustomIntegrationFields
        }
    }
    ${CUSTOM_INTEGRATION_FRAGMENT}
`;

export const CREATE_CUSTOM_INTEGRATION = gql`
    mutation CreateCustomIntegration(
        $name: String!
        $enabled: Boolean
        $baseUrl: String!
        $authId: String
        $authToken: String
        $config: JSONString
        $orderChannels: [UUID]
        $rfqChannels: [UUID]
    ) {
        createCustomIntegration(
            name: $name
            enabled: $enabled
            baseUrl: $baseUrl
            authId: $authId
            authToken: $authToken
            config: $config
            orderChannels: $orderChannels
            rfqChannels: $rfqChannels
        ) {
            integration {
                ...CustomIntegrationFields
            }
        }
    }
    ${CUSTOM_INTEGRATION_FRAGMENT}
`;

export const UPDATE_CUSTOM_INTEGRATION = gql`
    mutation UpdateCustomIntegration(
        $id: UUID!
        $name: String!
        $enabled: Boolean
        $baseUrl: String!
        $authId: String
        $authToken: String
        $extraData: JSONString
        $orderChannels: [UUID]
        $rfqChannels: [UUID]
    ) {
        updateCustomIntegration(
            id: $id
            name: $name
            enabled: $enabled
            baseUrl: $baseUrl
            authId: $authId
            authToken: $authToken
            extraData: $extraData
            orderChannels: $orderChannels
            rfqChannels: $rfqChannels
        ) {
            integration {
                ...CustomIntegrationFields
            }
        }
    }
    ${CUSTOM_INTEGRATION_FRAGMENT}
`;

export const DELETE_CUSTOM_INTEGRATION = gql`
    mutation DeleteCustomIntegration($id: UUID!) {
        deleteCustomIntegration(id: $id) {
            success
        }
    }
`;

// SharePoint

export const GET_SHAREPOINT_INTEGRATIONS = gql`
    query SharepointIntegrations {
        sharepointIntegrations {
            id
            name
            enabled
            createdAt
        }
    }
`;

export const GET_SHAREPOINT_SITES = gql`
    query SharepointSites($integrationId: UUID!, $search: String!) {
        sharepointSites(integrationId: $integrationId, search: $search) {
            id
            displayName
            webUrl
        }
    }
`;

export const GET_SHAREPOINT_DRIVES = gql`
    query SharepointDrives($integrationId: UUID!, $siteId: String!) {
        sharepointDrives(integrationId: $integrationId, siteId: $siteId) {
            id
            name
            webUrl
        }
    }
`;

export const GET_SHAREPOINT_ITEMS = gql`
    query SharepointItems($integrationId: UUID!, $driveId: String!, $itemId: String) {
        sharepointItems(integrationId: $integrationId, driveId: $driveId, itemId: $itemId) {
            id
            name
            webUrl
            isFolder
        }
    }
`;

export const CREATE_SHAREPOINT_INTEGRATION = gql`
    mutation CreateSharepointIntegration($name: String) {
        createSharepointIntegration(name: $name) {
            redirectUrl
            success
        }
    }
`;

export const DELETE_SHAREPOINT_INTEGRATION = gql`
    mutation DeleteSharepointIntegration($integrationId: UUID!) {
        deleteSharepointIntegration(integrationId: $integrationId) {
            success
        }
    }
`;

export const GET_SHAREPOINT_SHARE_LINK = gql`
    query SharepointShareLink($integrationId: UUID!, $url: String!) {
        sharepointShareLink(integrationId: $integrationId, url: $url) {
            driveId
            itemId
            name
            webUrl
        }
    }
`;

// Webhooks

const WEBHOOK_FRAGMENT = gql`
    fragment WebhookFields on WebhookType {
        id
        createdAt
        name
        enabled
        url
        authType
        authCredentials
        authHeader
        username
        password
        events
        showUnfinishedData
        orderChannels {
            id
            name
        }
        orderConfirmationChannels {
            id
            name
        }
        rfqChannels {
            id
            name
        }
        invoiceChannels {
            id
            name
        }
        deliveryNoteChannels {
            id
            name
        }
    }
`;

export const GET_WEBHOOKS = gql`
    query Webhooks {
        webhooks {
            ...WebhookFields
        }
    }
    ${WEBHOOK_FRAGMENT}
`;

export const CREATE_WEBHOOK = gql`
    mutation CreateWebhook(
        $name: String!
        $url: String!
        $enabled: Boolean
        $events: [String]
        $authType: String
        $authCredentials: String
        $authHeader: String
        $username: String
        $password: String
        $showUnfinishedData: Boolean
        $orderChannels: [UUID]
        $orderConfirmationChannels: [UUID]
        $rfqChannels: [UUID]
        $invoiceChannels: [UUID]
        $deliveryNoteChannels: [UUID]
    ) {
        createWebhook(
            name: $name
            url: $url
            enabled: $enabled
            events: $events
            authType: $authType
            authCredentials: $authCredentials
            authHeader: $authHeader
            username: $username
            password: $password
            showUnfinishedData: $showUnfinishedData
            orderChannels: $orderChannels
            orderConfirmationChannels: $orderConfirmationChannels
            rfqChannels: $rfqChannels
            invoiceChannels: $invoiceChannels
            deliveryNoteChannels: $deliveryNoteChannels
        ) {
            success
            webhook {
                ...WebhookFields
            }
        }
    }
    ${WEBHOOK_FRAGMENT}
`;

export const UPDATE_WEBHOOK = gql`
    mutation UpdateWebhook(
        $webhookId: UUID!
        $name: String
        $url: String
        $enabled: Boolean
        $events: [String]
        $authType: String
        $authCredentials: String
        $authHeader: String
        $username: String
        $password: String
        $showUnfinishedData: Boolean
        $orderChannels: [UUID]
        $orderConfirmationChannels: [UUID]
        $rfqChannels: [UUID]
        $invoiceChannels: [UUID]
        $deliveryNoteChannels: [UUID]
    ) {
        updateWebhook(
            webhookId: $webhookId
            name: $name
            url: $url
            enabled: $enabled
            events: $events
            authType: $authType
            authCredentials: $authCredentials
            authHeader: $authHeader
            username: $username
            password: $password
            showUnfinishedData: $showUnfinishedData
            orderChannels: $orderChannels
            orderConfirmationChannels: $orderConfirmationChannels
            rfqChannels: $rfqChannels
            invoiceChannels: $invoiceChannels
            deliveryNoteChannels: $deliveryNoteChannels
        ) {
            success
            webhook {
                ...WebhookFields
            }
        }
    }
    ${WEBHOOK_FRAGMENT}
`;

export const DELETE_WEBHOOK = gql`
    mutation DeleteWebhook($webhookId: UUID!) {
        deleteWebhook(webhookId: $webhookId) {
            success
        }
    }
`;

export const GET_CUSTOMER_PLAN_USAGE = gql`
    query {
        viewer {
            id
            customer {
                id
                planUsage {
                    planName
                    quota
                    usedQuota
                    seatLimit
                    usedSeats
                    chatAgentsEnabled
                    voiceAgentsEnabled
                    monthlyLlmTokenLimit
                    monthlyChatLlmCostLimit
                    usedMonthlyChatLlmCost
                    monthlyVoiceCallLimit
                    usedMonthlyVoiceCalls
                    monthlyVoiceCallMinutesLimit
                    usedMonthlyVoiceCallMinutes
                }
            }
        }
    }
`;
